<app-mobile-filter-magic-cont
  [hasFilterSelected]="hasActiveFilter"
  [title]="title"
  [styleByContext]="filterMagicContStyle"
  [individualFilter]="true"
  (clear)="clearSelectedFilterValues()">
  <ng-container body="body">
    <ng-container *ngIf="isSorterFilter(filter)">
      <app-sorter-filter
        [individualFilter]="true"
        [label]="'HOTELS_MODULE.RESULT_HOTELS.SORTER_LABEL'"
        [sorters]="filter.value"
        (sorter)="applySorter($event)"
        [isMobile]="true"
        [pickedSorter]="pickedPackageHotelSorter$ | async">
      </app-sorter-filter>
    </ng-container>
    
    <ng-container *ngIf="isStarsFilter(filter)">
      <app-stars-filter
        [individualFilter]="true"
        [list]="filter.value"
        [pickedStars]="pickedStars"
        [isClear]="isClearSelectedStars"
        (clearSelectedItems)="clearSelectedStars(false)"
        (selectStar)="applyFilterStar(filter.type, $event)">
      </app-stars-filter>
    </ng-container>

    <ng-container *ngIf="isRadioFilter(filter)">
      <app-radio-filter
        [options]="filter.value"
        [individualFilter]="true"
        [pickedTotalDiscountPercentage]="pickedRadioTotalDiscountPercentage"
        [type]="filter.type"
        [isMobile]="true"
        [isOpenBox]="true"
        (filter)="applyFilterVm($event)">
      </app-radio-filter>
    </ng-container>
    
    <ng-container *ngIf="isCheckboxFilter(filter)">
      <app-checkbox-filter
        [options]="filter.value"
        [pickedCheckboxes]="pickedCheckboxes$ | async"
        [individualFilter]="true"
        [type]="filter.type"
        [isOpenBox]="true"
        [noTranslate]="true"
        [isMobile]="true"
        (filter)="applyFilterVm($event)">
      </app-checkbox-filter>
    </ng-container>
  </ng-container>
</app-mobile-filter-magic-cont>
